import { makeAutoObservable } from "mobx";
import { createPatientService } from "~/services/patient";
import { INewPatientEntity, INewPatientPayload } from "~/types/patient";
import RootStore from "~/store/RootStore";
import { ResponseStatusCode } from "~/types/request";

class Patient {
  rootStore!: RootStore;

  currentPatient: INewPatientEntity | null = JSON.parse(
    localStorage.getItem("currentPatient") ?? "null"
  );

  constructor(root: RootStore) {
    makeAutoObservable(this);
    this.rootStore = root;
  }

  setCurrentPatient(patient: INewPatientEntity | null) {
    localStorage.setItem("currentPatient", JSON.stringify(patient));
    this.currentPatient = patient;
  }

  get currentPatientAge(): number | null {
    if (!this.currentPatient) {
      return null;
    }

    const birthDate = new Date(
      `${this.currentPatient.birthday.substring(
        6
      )}/${this.currentPatient.birthday.substring(
        3,
        5
      )}/${this.currentPatient.birthday.substring(0, 2)}`
    );
    const otherDate = new Date();

    let years = otherDate.getFullYear() - birthDate.getFullYear();

    if (
      otherDate.getMonth() < birthDate.getMonth() ||
      (otherDate.getMonth() == birthDate.getMonth() &&
        otherDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }

    return years;
  }

  async createPatient(payload: INewPatientPayload) {
    this.rootStore.systemStore.loadingStart();

    try {
      const response = await createPatientService(payload);

      if (response.data.code === ResponseStatusCode.EGISError) {
        this.rootStore.egisErrorStore.setIsEgisErrorRelatedToAssign(true);
        throw new Error(response.data.message);
      }

      return response.data;
    } finally {
      this.rootStore.systemStore.loadingEnd();
    }
  }
}

export default Patient;
